/* eslint-disable */
import React, {useEffect, useRef, useState} from 'react';
import T from 'prop-types';
import {nanoid} from 'nanoid';
import moment from 'moment-timezone';
import {isEqual} from 'lodash';
import {Form, Formik} from 'formik';
import {ConnectedFocusError} from 'focus-formik-error';
import {toast} from 'react-toastify';
import {TopLineNav} from '../../../../components/layout';
import LinkBack from '../../../../components/LinkBack/styles';
import DashboardContent from '../../../../components/DashboardContent/styles';
import DashboardInner from '../../../../components/DashboardInner/styles';
import {NavLink, useHistory} from 'react-router-dom';
import {
  AccordionItem,
  AccordionItemBody,
  AccordionItemName,
  DashboardField,
  DashboardFields,
  DashboardInnerDescription,
  DashboardText,
  DashboardTimeInner,
  DialogFieldRemove,
  DialogLinkButton,
  FieldInputDollar
} from '../../dashboard/styles';
import FieldLabel from '../../../../components/FieldLabel/styles';
import FieldInput from '../../../../components/FieldInput';
import Subtitle5 from '../../../../components/typography/Subtitle5';
import Subtitle6 from '../../../../components/typography/Subtitle6';
import DashboardTitle from '../../../../components/DashboardTitle/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ButtonInfo, ButtonPrimary} from '../../../../components/buttons';
import {FormControl, RadioGroup, TextField} from '@material-ui/core';
import RadioS2E from '../../../../components/Radiobox';
import {MobileTimePicker} from '@material-ui/pickers';
import SingleDatepickerDrop from '../../../../components/SingleDatepickerDrop';
import cn from 'classnames';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SelectWrapper from '../../../../components/select/SelectComponentStyles';
import AutocompletedMapField from '../../settings/LocationMap/AutocompletedMapField';
import BookADriverSchema from '../../../../helpers/services/formValidationSchemas/BookADriverSchema';
import {
  ErrorSign,
  ErrorSignWrapper
} from '../../../../components/errorSign/errorSign';
import {useDispatch, useSelector} from 'react-redux';
import {
  HANDLE_FAIL_MODAL,
  POST_BAD_ORDER,
  GET_ADDRESSES,
  CLEAR_BAD_ORDER_DETAIL,
  CHECK_ADDRESS,
  GET_ADDRESSES_SUCCESS
} from '../../../../store/bookADriver/bookADriverCreate/action';
import OrderFail from '../Modals/OrderFail';
import FieldMaskInput from '../../../../components/FieldMaskInput';
import CardsButtonGrid from '../../../../components/CardsButtonGrid/styles';
import CardsButton from '../../../../components/CardsButton/styles';
import IconASAP from '../../../../assets/IconASAP';
import IconFutureDelivery from '../../../../assets/IconFutureDelivery';
import {
  integerFormatter,
  phoneNumberFormatter,
  toE164UsPhone
} from '../../../../helpers/functionUtils/helpFunctions';
import BADRadioButtons from '../../../../components/BADRadioButtons/styles';
import BADCreateTotal from '../../../../components/BADCreateTotal/styles';
import ButtonClear from '../../../../components/buttons/ButtonClear/styles';
import Loading from '../../../../components/shared/Utils/Loading';
import BADStoreAddressErrorModal from '../Modals/BADStoreAddressErrorModal';
import Body1 from '../../../../components/typography/Body1';
import Subtitle from '../../../../components/typography/Subtitle1';
import Subtitle1 from '../../../../components/typography/Subtitle1';
import Subtitle4 from '../../../../components/typography/Subtitle4';
import AnimatePoints from '../../../../components/AnimatePoints';
import AnimatePointsContainer from '../../../../components/AnimatePoints/styles';
import sendGtmEvent from '../../../../helpers/services/utils/gtm';
import BADRecommendationText from '../../../../components/BADRecommendationText/styles';
import {getSessionStorageItem} from '../../../../helpers/sessionStorage';
import SESSION_SAUCE_EMPLOYEE_NAME from '../../../../helpers/sessionStorage/constants';
import {
  BAD_REASONS,
  BAD_REASONS_SAUCE_ONLY,
  BOOK_A_DRIVER_ERROR,
  LOS_ANGELES_ZIP_CODES,
  NEW_YORK_ZIP_CODES_RANGE1,
  NEW_YORK_ZIP_CODES_RANGE2,
  NEW_YORK_ZIP_CODES_RANGE3,
  NEW_YORK_ZIP_CODES_RANGE4,
  NEW_YORK_ZIP_CODES_RANGE5,
  NEW_YORK_ZIP_CODES_RANGE6,
  hideEmail
} from 'helpers/constants/bookAdriver';
import {getBookADriverVersion} from '../../../../helpers/constants/restrictions';
import {shouldBlockBookADriverForClosedLocation} from 'helpers/functionUtils/bookADriver';
import TestOrderModeToast from '../components/TestOrderModeToast';

const DISTANCE = {
  0: 2.0,
  1: 2.0,
  2: 2.0,
  3: 3.0,
  4: 3.0,
  5: 3.0,
  6: 4.0,
  7: 4.0,
  8: 5.0,
  9: 5.0,
  10: 6.0,
  11: 7.0,
  12: 7.0,
  13: 8.0,
  14: 8.0,
  15: 9.0,
  16: 10.0,
  17: 10.0,
  18: 11.0,
  19: 11.0,
  20: 12.0
};

const ASAPFoodTime = [
  {name: 'Now (no ordering delay)', id: 0},
  {name: '5 min', id: 5},
  {name: '10 min', id: 10},
  {name: '15 min', id: 15},
  {name: '20 min', id: 20},
  {name: '25 min', id: 25},
  {name: '30 min', id: 30}
];

const DEFAULT_TIPS = '20';

function CreateOrder() {
  const history = useHistory();
  const dispatch = useDispatch();
  const formikRef = useRef();
  const {order, addresses, checkAddressLoading, checkAddress} = useSelector(
    (state) => state.bookADriverCreateReducer
  );
  const isSuccessOrder = useSelector(
    (state) => state.bookADriverCreateReducer.openSuccessModal
  );
  const isFailOrder = useSelector(
    (state) => state.bookADriverCreateReducer.openFailModal
  );
  const isFailOrderData = useSelector(
    (state) => state.bookADriverCreateReducer.failData
  );
  const {activeLocation, userData} = useSelector((state) => state.user);
  const isClosedForBookADriver = shouldBlockBookADriverForClosedLocation(
    activeLocation
  );
  const TimezoneId = activeLocation?.TimezoneId || 'America/New_York';
  const isCateringLocation = !!(
    activeLocation?.IsCatering || activeLocation?.DeliveryOptions?.IsCatering
  );
  const {AllowedServiceFeatures} = useSelector(
    (state) => state.user.activeLocation
  );
  // Catering PickupDate is store wall-clock digits. A trailing Z is not UTC.
  const STORE_WALL_CLOCK = 'YYYY-MM-DDTHH:mm:ss';
  const STORE_WALL_CLOCK_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  const toStoreWallClock = (value) => {
    if (!value) return '';
    const wallClock =
      typeof value === 'string'
        ? value.substring(0, 19)
        : moment(value).format(STORE_WALL_CLOCK);
    return STORE_WALL_CLOCK_RE.test(wallClock) ? wallClock : '';
  };
  const toUtcInstant = (wallClock) =>
    moment.tz(wallClock, STORE_WALL_CLOCK, TimezoneId).utc().format();
  // Default suggestion (+2h). User may edit earlier, down to the allowed min (+1h).
  const getCateringDefaultPickupDate = () =>
    moment().tz(TimezoneId).add(2, 'hours').format(STORE_WALL_CLOCK);
  const getCateringMinAllowedPickupDate = () =>
    moment().tz(TimezoneId).add(1, 'hour').format(STORE_WALL_CLOCK);
  // Same 30-day max as BE.
  const getCateringMaxPickupDate = () =>
    moment().tz(TimezoneId).add(30, 'days').format(STORE_WALL_CLOCK);
  const clampCateringPickup = (value) => {
    const min = getCateringMinAllowedPickupDate();
    const max = getCateringMaxPickupDate();
    const pickup = toStoreWallClock(value) || getCateringDefaultPickupDate();
    if (pickup < min) return min;
    if (pickup > max) return max;
    return pickup;
  };
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [expanded, setExpanded] = useState(false);
  const [stopUseEffect, setStopUseEffect] = useState(false);
  const [addressesList, setAddressesList] = useState(addresses);
  const [storeAddressError, setStoreAddressError] = useState(false);
  const [isV2, setIsV2] = useState(false);
  const [isTestOrderMode, setIsTestOrderMode] = useState(false);
  const [lastSentBody, setLastSentBody] = useState(null);
  const clickTimestamps = useRef([]);

  const contentRef = useRef(null);
  const backdropRef = useRef(null);

  useEffect(() => {
    if (contentRef.current && backdropRef.current) {
      backdropRef.current.style.height = `${contentRef.current.scrollHeight}px`;
    }
  }, [checkAddressLoading]);

  const dateWithoutLocalTimezone = (date) => {
    let newDate = date;
    const currentTimezone = (new Date().getTimezoneOffset() / 60).toString();
    if (currentTimezone && currentTimezone.split('')[0] === '-') {
      newDate = moment(newDate)
        .set(
          'hours',
          moment(newDate).get('hours') - currentTimezone.split('')[1]
        )
        .toDate();
    } else if (
      currentTimezone &&
      currentTimezone.split('')[0] !== '-' &&
      currentTimezone.split('').length === 1
    ) {
      newDate = moment(newDate)
        .set(
          'hours',
          moment(newDate).get('hours') + currentTimezone.split('')[0]
        )
        .toDate();
    }
    return newDate;
  };

  const dateToTimezone = (date) => {
    if (!date) return date;

    const wallClock = moment(date).format('YYYY-MM-DDTHH:mm:ss');
    return moment.tz(wallClock, TimezoneId).toDate();
  };

  const setItemCount = (items) => {
    if (items) {
      let itemCount = 0;
      items.forEach((item) => {
        itemCount += item.quantity;
      });
      return itemCount.toString();
    }
  };

  useEffect(() => {
    let orderType = isCateringLocation ? 'FutureDelivery' : 'ASAP';
    const version = getBookADriverVersion(AllowedServiceFeatures || []);
    if (version === 'v2') {
      setIsV2(true);
    }
    if (
      activeLocation?.StructuredAddress?.FormattedAddress &&
      activeLocation?.StructuredAddress?.FormattedAddress?.split(', ').length <
        3
    ) {
      setStoreAddressError(true);
      return;
    }
    if (
      activeLocation?.StructuredAddress?.FormattedAddress !==
      initValues.StoreAddress
    ) {
      const addressLoc = activeLocation?.StructuredAddress?.FormattedAddress?.trim();
      const address = addressLoc.split(', ');
      let newInitValuesObj = {
        ...initValues,
        StoreAddress: activeLocation?.StructuredAddress?.FormattedAddress,
        StoreAddressNumber: activeLocation?.StructuredAddress?.StreetNumber
          ? activeLocation?.StructuredAddress?.StreetNumber
          : address[0].split(' ')[0],
        StoreAddressStreet: activeLocation?.StructuredAddress?.StreetName
          ? activeLocation?.StructuredAddress?.StreetName
          : address[0].split(' ').slice(1).join(' '),
        StoreAddressCity: activeLocation?.StructuredAddress?.City
          ? activeLocation?.StructuredAddress?.City
          : address[1],
        StoreAddressState: activeLocation?.StructuredAddress?.StateCode
          ? activeLocation?.StructuredAddress?.StateCode
          : address[2].split(' ')[0],
        StoreAddressZip: activeLocation?.StructuredAddress?.ZipCode
          ? activeLocation?.StructuredAddress?.ZipCode
          : address[2].split(' ')[1],
        StoreCor: {
          lat:
            activeLocation?.StructuredAddress?.Latitude &&
            Number(activeLocation?.StructuredAddress?.Latitude)
              ? Number(activeLocation?.StructuredAddress?.Latitude)
              : activeLocation.Latitude,
          lng:
            activeLocation?.StructuredAddress?.Longitude &&
            Number(activeLocation?.StructuredAddress?.Longitude)
              ? Number(activeLocation?.StructuredAddress?.Longitude)
              : activeLocation.Longitude
        }
      };
      if (order && Object.keys(order).length) {
        let pickupDate;
        if (isCateringLocation) {
          pickupDate = clampCateringPickup(order?.date);
        } else if (order?.orderStatus === 'Future Order' && order?.date) {
          pickupDate = dateWithoutLocalTimezone(order?.date);
        } else {
          pickupDate = moment(dateToTimezone(new Date()))
            .set(
              'minutes',
              moment(dateToTimezone(new Date())).get('minutes') +
                60 +
                activeLocation.PickupEtaMinutes
            )
            .toDate();
        }
        newInitValuesObj = {
          ...newInitValuesObj,
          Email: order?.userEmail || 'orders@getsauce.com',
          FirstName: order?.userName?.split(' ')[0],
          LastName: order?.userName?.split(' ')[1],
          Subtotal: order?.orderInfo?.total?.toFixed(2).toString(),
          ItemCount: setItemCount(order?.orderInfo?.items),
          ContainAlcohol: !!order?.orderInfo?.alcoholTax,
          Address: order?.orderInfo?.deliveryAddress || '',
          FullAddress: order?.orderInfo?.deliveryAddress || '',
          StreetNumber:
            order?.orderInfo?.deliveryAddressDecode?.Address?.Number || '',
          Street:
            order?.orderInfo?.deliveryAddressDecode?.Address?.Street || '',
          City: order?.orderInfo?.deliveryAddressDecode?.Address?.City || '',
          State: order?.orderInfo?.deliveryAddressDecode?.Address?.State || '',
          ZipCode:
            order?.orderInfo?.deliveryAddressDecode?.Address?.ZipCode || '',
          PickupDate: pickupDate,
          Phone: order?.userPhone
            ? phoneNumberFormatter(order?.userPhone).substr(-10, 10)
            : '',
          Location: {
            lat: order?.orderInfo?.deliveryAddressDecode?.Сoordinates?.Latitude,
            lng: order?.orderInfo?.deliveryAddressDecode?.Сoordinates?.Longitude
          },
          Notes: {
            notes: order?.orderInfo?.deliveryAddressDetails?.Notes || '',
            apt: order?.orderInfo?.deliveryAddressDetails?.Apt || '',
            entrance: order?.orderInfo?.deliveryAddressDetails?.Entrance || '',
            floor: order?.orderInfo?.deliveryAddressDetails?.Floor || ''
          },
          CourierTip: DEFAULT_TIPS,
          ...(order?.id && {CoreOrderId: order.id}),
          ...(order?.invoiceID && {InvoiceId: order.invoiceID}),
          ...(order?.coreOrderType && {CoreOrderType: order.coreOrderType}),
          HideEmail: false,
          ...(order?.orderSource && {
            ExternalOrderProviderName: order.orderSource
          })
        };
        if (
          isCateringLocation ||
          (order.orderStatus === 'Future Order' && order.date)
        ) {
          orderType = 'FutureDelivery';
          setActive('FutureDelivery');
        }
        const version = getBookADriverVersion(AllowedServiceFeatures || []);
        if (version === 'v2') {
          setIsV2(true);
        }
      }
      setInitValues(newInitValuesObj);
      checkDeliveryAddress(newInitValuesObj, orderType);
    }
  });

  useEffect(() => {
    if (addresses) {
      const newInitValuesObj = {
        ...initValues,
        Email: addresses?.customer_email,
        FirstName: addresses?.s2e_meta?.dropoff?.name.split(' ')[0],
        LastName: addresses?.s2e_meta?.dropoff?.name.split(' ')[1],
        StreetNumber: addresses?.s2e_meta?.dropoff?.number,
        Street: addresses?.s2e_meta?.dropoff?.street,
        City: addresses?.s2e_meta?.dropoff?.city,
        State: addresses?.s2e_meta?.dropoff?.state,
        ZipCode: addresses?.s2e_meta?.dropoff?.zip,
        Address: addresses?.s2e_meta?.dropoff?.address,
        FullAddress: addresses?.s2e_meta?.dropoff?.address,
        Phone: addresses?.s2e_meta?.dropoff?.phone?.replace('+1', ''),
        Notes: {
          notes: addresses?.s2e_meta?.dropoff?.notes || '',
          apt: addresses?.s2e_meta?.dropoff?.apt || '',
          entrance: addresses?.s2e_meta?.dropoff?.entrance || '',
          floor: addresses?.s2e_meta?.dropoff?.floor || ''
        },
        Location: {
          lat: addresses?.s2e_meta?.dropoff?.lat,
          lng: addresses?.s2e_meta?.dropoff?.lng
        }
      };
      setInitValues(newInitValuesObj);
      checkDeliveryAddress(newInitValuesObj, isActive);
    }
  }, [addresses]);

  useEffect(() => {
    return () => {
      dispatch(CLEAR_BAD_ORDER_DETAIL());
      // dispatch(GET_ADDRESSES({}));
    };
  }, []);

  /*useEffect(() => {
        setCheck(checkAddress)
      }, [checkAddress])*/

  useEffect(() => {
    if (isSuccessOrder) {
      history.push('/book-a-driver/active');
    }
  });

  useEffect(() => {
    if (checkAddress) {
      /*setInitValues({
                    ...initValues,
                    DeliveryPrice: checkAddress?.delivery_cost
                  })*/
      // formikRef?.current?.setFieldValue(
      //   'DeliveryPrice',
      //   checkAddress?.delivery_cost || 0
      // );
      if (
        formikRef?.current?.values.DeliveryDistance !==
        Number(checkAddress?.delivery_distance?.toFixed(2))
      ) {
        if (isV2) {
          formikRef?.current?.setFieldValue('CourierTip', 'Custom');
          formikRef?.current?.setFieldValue(
            'Amount',
            checkAddress?.default_tip / 100 || 0
          );
          formikRef?.current?.setFieldValue(
            'CourierTipNumber',
            checkAddress?.default_tip || 0
          );
        } else {
          calculateDeliveryPrice({
            ...formikRef?.current?.values,
            DeliveryDistance:
              Number(checkAddress?.delivery_distance?.toFixed(2)) || 0
          });
        }
        formikRef?.current?.setFieldValue(
          'DeliveryDistance',
          Number(checkAddress?.delivery_distance?.toFixed(2)) || 0
        );
      }
      formikRef?.current?.setFieldValue(
        'DeliveryPrice',
        checkAddress?.delivery_price ? checkAddress?.delivery_price : 0
      );
    }
  }, [checkAddress]);

  const [initValues, setInitValues] = useState({
    StoreAddress: '',
    StoreAddressNumber: '',
    StoreAddressStreet: '',
    StoreAddressCity: '',
    StoreAddressState: '',
    StoreAddressZip: '',
    StoreCor: {
      lat: null,
      lng: null
    },
    CountryCode: '+1',
    Phone: '',
    Email: '',
    FirstName: '',
    LastName: '',
    FullAddress: '',
    Address: '',
    StreetNumber: '',
    Street: '',
    City: '',
    State: '',
    Country: '',
    Location: {},
    Notes: {
      apt: '',
      floor: '',
      entrance: '',
      notes: ''
    },
    Subtotal: '',
    CourierTip: '',
    CourierTipNumber: 0,
    Amount: '',
    ItemCount: '',
    Catering: false,
    DeliveryPrice: 0,
    DeliveryDistance: 0,
    ContainAlcohol: false,
    PickupDate: moment()
      .tz(TimezoneId)
      .add(60, 'minutes')
      .format()
      .substring(0, 19),
    MinDate: moment()
      .tz(TimezoneId)
      .add(60, 'minutes')
      .format()
      .substring(0, 19),
    PickupDateNow: moment().tz(TimezoneId).format(),
    ASAPFoodPreparationTime: 5,
    ...(getBookADriverVersion(AllowedServiceFeatures || []) === 'v2' && {
      Reason: '',
      AmountOfDrivers: null,
      IsV2: true,
      PercentTipAmount: 0,
      CourierTip: ''
    }),
    HideEmail: hideEmail(AllowedServiceFeatures, order)
  });
  const fmtDate = function (date) {
    let d = date.toISOString().split(':');
    d.push(d.pop().split('.')[0]);
    return d.join(':') + 'Z';
  };

  const addItem = (itemClass) => {
    const copy = [...items];
    copy.push({name: '', quantity: 1});
    setItems([...copy], itemClass);
  };

  const [disableButton, setDisableButton] = useState(false);

  const [items, setItems] = useState([]);
  useEffect(() => {
    if (items.length > 0) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, [items]);

  const handleItemItems = (i, value) => {
    const copy = [...items];
    copy[i].name = value;
    setItems(copy);
  };

  const onChangeInitValues = (e) => {
    setInitValues({
      ...initValues,
      [e.target.name]: e.target.value
    });
  };

  const computedAddItem = (items) => {
    const haveEmptyItem = Boolean(items.find((elem) => elem.name === ''));
    if (haveEmptyItem) {
      return 'disabled';
    }
    return '';
  };

  const disabledSubmitButton = (value) => {
    if (value) {
      return 'ButtonBookADriver disabled';
    }
    return 'ButtonBookADriver';
  };

  const handleItemQuantity = (i, value) => {
    const copy = [...items];
    copy[i].quantity = value;
    setItems(copy);
  };

  const removeItem = (i) => {
    const copy = [...items];

    copy.splice(i, 1);

    setItems(copy);
  };
  const getMinTime = (date) => {
    if (isCateringLocation) {
      // Only constrain time-of-day on the earliest allowed calendar day (catering).
      const min = getCateringMinAllowedPickupDate();
      const selected = toStoreWallClock(date) || min;
      return selected.substring(0, 10) === min.substring(0, 10)
        ? min
        : undefined;
    }

    const isSameDayAsNow =
      moment(date).get('day') === moment(initValues.PickupDateNow).get('day') &&
      moment(date).get('month') ===
        moment(initValues.PickupDateNow).get('month');

    if (isSameDayAsNow) {
      return moment()
        .tz(TimezoneId)
        .add(60, 'minutes')
        .format()
        .substring(0, 19);
    }
  };

  const getMaxTime = (date) => {
    if (!isCateringLocation) return undefined;
    const max = getCateringMaxPickupDate();
    const selected = toStoreWallClock(date) || max;
    return selected.substring(0, 10) === max.substring(0, 10) ? max : undefined;
  };

  const getAddresses = (e) => {
    if (e.target.value) {
      dispatch(GET_ADDRESSES(`+1${phoneNumberFormatter(e.target.value)}`));
    }
  };

  const amountFormatter = (newValue, prevValue = '', field, subtotal) => {
    if (newValue === '') {
      return '';
    }

    let formedNewValue = newValue.replace(',', '.').replace('%', '');
    let resValue;
    if (field !== 'ItemCount') {
      resValue =
        formedNewValue.substr(-1) === '0'
          ? (resValue = formedNewValue)
          : (resValue = parseFloat(formedNewValue));
    } else {
      resValue = parseInt(formedNewValue);
    }

    if (!resValue) {
      return prevValue ? resValue : '';
    }

    if (formedNewValue.length > 6 && field === 'amount') {
      return prevValue;
    }

    if (
      formedNewValue.indexOf('.') !== formedNewValue.lastIndexOf('.') &&
      field !== 'ItemCount'
    ) {
      return prevValue;
    }

    if (
      (resValue > 150 && field === 'amount') ||
      (subtotal && resValue > subtotal && field === 'amount') ||
      (resValue > 99 && field === 'ItemCount') ||
      (resValue > 10000 && field === 'subtotal')
    ) {
      return prevValue;
    }

    if (formedNewValue.slice(-1) === '.' && field !== 'ItemCount') {
      resValue = `${resValue}.`;
    }
    if (String(resValue).split('.')[1]?.length > 2 && field !== 'ItemCount') {
      return prevValue;
    }

    return resValue;
  };
  const [isActive, setActive] = useState(
    isCateringLocation ? 'FutureDelivery' : 'ASAP'
  );

  // Location can load after first paint — force Future delivery for catering.
  useEffect(() => {
    if (!isCateringLocation) return;
    setActive('FutureDelivery');
    const cateringPickupDate = clampCateringPickup(order?.date);
    const cateringMinAllowedDate = getCateringMinAllowedPickupDate();
    setInitValues((prev) => ({
      ...prev,
      PickupDate: cateringPickupDate,
      MinDate: cateringMinAllowedDate
    }));
    formikRef?.current?.setFieldValue('PickupDate', cateringPickupDate);
    formikRef?.current?.setFieldValue('MinDate', cateringMinAllowedDate);
  }, [isCateringLocation, TimezoneId, order?.date]);

  const toggleClass = (buttonName) => {
    // Keep ASAP visible for catering locations, but block selection and notify the user.
    if (isCateringLocation && buttonName === 'ASAP') {
      toast.info(
        'ASAP is not available for catering locations. Please schedule a future delivery.'
      );
      return;
    }
    if (formikRef?.current?.values?.Catering && buttonName === 'ASAP') {
      return;
    }
    setActive(buttonName);
  };

  const getASAPTime = () => {
    let newDate;
    newDate = moment()
      .set('minutes', moment().get('minutes') + activeLocation.PickupEtaMinutes)
      .utcOffset(0, false)
      .toDate();

    return newDate;
  };

  const checkDeliveryAddress = (value, orderType) => {
    if (isClosedForBookADriver) {
      return;
    }

    // Catering locations must always quote as future, never ASAP.
    const resolvedOrderType = isCateringLocation ? 'FutureDelivery' : orderType;
    let resolvedValue = value;
    if (isCateringLocation) {
      const cateringMinAllowedDate = getCateringMinAllowedPickupDate();
      resolvedValue = {
        ...value,
        PickupDate: clampCateringPickup(value.PickupDate),
        MinDate: cateringMinAllowedDate
      };
    }

    if (resolvedValue.FullAddress && resolvedValue.StoreAddress) {
      if (!resolvedValue.Street) {
        formikRef?.current?.setErrors({
          Street:
            'Your address does not have any street specified. Please select another address or choose address with street specified!'
        });
        formikRef?.current?.setFieldTouched('Address');
        return;
      }
      if (!resolvedValue.City) {
        formikRef?.current?.setErrors({
          City:
            'Your address does not have any city specified. Please select another address or choose address with city specified!'
        });
        formikRef?.current?.setFieldTouched('Address');
        return;
      }
      if (!resolvedValue.State) {
        formikRef?.current?.setErrors({
          State:
            'Your address does not have any state specified. Please select another address or choose address with state specified!'
        });
        formikRef?.current?.setFieldTouched('Address');
        return;
      }
      if (!resolvedValue.ZipCode) {
        formikRef?.current?.setErrors({
          ZipCode:
            'Your address does not have any zip code specified. Please select another address or choose address with zip code specified!'
        });
        formikRef?.current?.setFieldTouched('Address');
        return;
      }
      const body = {
        pickup: {
          name:
            activeLocation?.BusinessName?.trim() ||
            activeLocation?.FullName?.trim(),
          phone: phoneNumberFormatter(activeLocation.Phone),
          address: {
            number: resolvedValue.StoreAddressNumber,
            street: resolvedValue.StoreAddressStreet,
            city: resolvedValue.StoreAddressCity,
            state: resolvedValue.StoreAddressState,
            zip: resolvedValue.StoreAddressZip
          }
        },
        pickup_loc: resolvedValue.StoreCor,
        dropoff: {
          name: 'John Doe',
          phone: '+13055865684',
          address: {
            number: resolvedValue.StreetNumber || '',
            street: resolvedValue.Street,
            city: resolvedValue.City,
            state: resolvedValue.State,
            zip: resolvedValue.ZipCode
          }
        },
        pickup_business_name:
          activeLocation?.BusinessName?.trim() ||
          activeLocation?.FullName?.trim(),
        dropoff_loc: resolvedValue.Location,
        order_value: resolvedValue.Subtotal
          ? Number((resolvedValue.Subtotal * 100).toFixed(0))
          : 100,
        is_catering: isCateringLocation,
        ...(resolvedValue.ExternalOrderProviderName && {
          external_order_provider_name: resolvedValue.ExternalOrderProviderName
        })
      };
      if (resolvedOrderType === 'ASAP') {
        body.food_preparation_time =
          resolvedValue.ASAPFoodPreparationTime ||
          activeLocation.PickupEtaMinutes;
      }
      if (resolvedOrderType === 'FutureDelivery') {
        body.dropoff_time = getFutureDate(resolvedValue);
      }
      if (isTestOrderMode) {
        body.is_test = true;
      }

      if (lastSentBody && isEqual(body, lastSentBody)) {
        return;
      }

      setLastSentBody(body);
      // Determine version: use value.IsV2 if set, otherwise check based on feature flags
      const version =
        resolvedValue.IsV2 !== undefined
          ? resolvedValue.IsV2
          : getBookADriverVersion(AllowedServiceFeatures || []) === 'v2';
      dispatch(CHECK_ADDRESS({body, isV2: version}));
    }
  };

  function getRestaurantDeliveryArea(distance) {
    const delivery = activeLocation.Delivery || [];
    if (delivery.length) {
      const onlyCustomerCharge = delivery.filter(
        (item) => Number(item.DeliverySay2eatFee) <= Number(item.DeliveryPrice)
      );
      if (onlyCustomerCharge.length) {
        return 'Only customer charge';
      }
      const filterDeliveryArea = delivery.filter(
        (item) => item.RadialDeliveryArea > distance
      );
      return filterDeliveryArea.length
        ? filterDeliveryArea[0]
        : 'Have not delivery area';
    }
  }

  function calcRestaurantSubsidizing(distance) {
    const deliveryArea = getRestaurantDeliveryArea(distance);
    if (deliveryArea === 'Only customer charge') {
      return null;
    } else if (deliveryArea === 'Have not delivery area') {
      const maxMiles = Object.keys(DISTANCE)[Object.keys(DISTANCE).length - 1];
      return Number(distance.toFixed(0)) <= maxMiles
        ? DISTANCE[distance.toFixed(0)].toFixed(2)
        : DISTANCE[maxMiles].toFixed(2);
    } else {
      return (
        Number(deliveryArea.DeliverySay2eatFee) -
        Number(deliveryArea.DeliveryPrice)
      ).toFixed(2);
    }
  }

  const calculateTip = (subtotal, courierTip, amount) => {
    if (subtotal && courierTip !== 'Custom' && courierTip !== 0) {
      return Number((Number(subtotal) * Number(courierTip)).toFixed(0));
    } else if (subtotal && courierTip === 'Custom' && amount) {
      return amount * 100;
    } else if (
      (subtotal && courierTip === 0) ||
      !subtotal ||
      (courierTip === 'Custom' && !amount)
    ) {
      return 0;
    }
  };

  const onCloseStoreAddressErrorModal = () => {
    setStoreAddressError(false);
    history.push('/store-settings');
  };

  const getFutureDate = (values) => {
    // Catering: interpret wall-clock in location TZ → UTC once (avoid double offset).
    if (isCateringLocation) {
      return toUtcInstant(clampCateringPickup(values?.PickupDate));
    }

    // Non-catering: keep existing conversion unchanged.
    const offsetInHours =
      moment.tz(values.PickupDate, TimezoneId).utcOffset() / 60;

    let result;
    if (values.PickupDate === values.MinDate) {
      result = moment(values.MinDate)
        .utcOffset(offsetInHours, true)
        .utc()
        .format();
    } else {
      result = moment(moment.utc(values.PickupDate).format())
        .utcOffset(offsetInHours, true)
        .utc()
        .format();
    }
    return result;
  };

  const setDateOrTime = (value, setFieldValue, formikValues) => {
    if (isCateringLocation) {
      const date = clampCateringPickup(value);
      const minAllowed = getCateringMinAllowedPickupDate();
      setFieldValue('PickupDate', date);
      setFieldValue('MinDate', minAllowed);
      checkDeliveryAddress(
        {...formikValues, PickupDate: date, MinDate: minAllowed},
        'FutureDelivery'
      );
      return;
    }

    // Non-catering: keep existing behavior unchanged.
    let date;
    if (moment(value).isBefore(formikValues.MinDate)) {
      date = formikValues.MinDate;
    } else {
      date = moment.utc(value).format();
    }
    setFieldValue('PickupDate', date);
    checkDeliveryAddress({...formikValues, PickupDate: date}, isActive);
  };

  function calculateTipAndAmount(percent, subtotal, currentValue) {
    const feeWithPercent = +(Number(subtotal) * (percent / 100));
    if (getSessionStorageItem(SESSION_SAUCE_EMPLOYEE_NAME)) {
      formikRef?.current?.setFieldValue(
        'CourierTip',
        feeWithPercent
          ? feeWithPercent < currentValue
            ? percent
            : 'Custom'
          : percent
      );
      formikRef?.current?.setFieldValue(
        'CourierTipNumber',
        feeWithPercent < currentValue
          ? +(feeWithPercent * 100).toFixed(2)
          : currentValue * 100
      );
      formikRef?.current?.setFieldValue(
        'Amount',
        feeWithPercent < currentValue ? '' : currentValue
      );
    } else {
      formikRef?.current?.setFieldValue('CourierTip', percent);
      formikRef?.current?.setFieldValue('Amount', '');
    }
  }

  // const checkNewYorkOrLosAngeles = (state, zip) => {
  //   return (
  //     (state === 'NY' || state === 'LA') &&
  //     (LOS_ANGELES_ZIP_CODES.includes(Number(zip)) ||
  //       (Number(zip) >= NEW_YORK_ZIP_CODES_RANGE1[0] &&
  //         Number(zip) <= NEW_YORK_ZIP_CODES_RANGE1[1]) ||
  //       (Number(zip) >= NEW_YORK_ZIP_CODES_RANGE2[0] &&
  //         Number(zip) <= NEW_YORK_ZIP_CODES_RANGE2[1]) ||
  //       (Number(zip) >= NEW_YORK_ZIP_CODES_RANGE3[0] &&
  //         Number(zip) <= NEW_YORK_ZIP_CODES_RANGE3[1]) ||
  //       (Number(zip) >= NEW_YORK_ZIP_CODES_RANGE4[0] &&
  //         Number(zip) <= NEW_YORK_ZIP_CODES_RANGE4[1]) ||
  //       (Number(zip) >= NEW_YORK_ZIP_CODES_RANGE5[0] &&
  //         Number(zip) <= NEW_YORK_ZIP_CODES_RANGE5[1]) ||
  //       (Number(zip) >= NEW_YORK_ZIP_CODES_RANGE6[0] &&
  //         Number(zip) <= NEW_YORK_ZIP_CODES_RANGE6[1]))
  //   );
  // };

  const calculateDeliveryPrice = (values) => {
    calculateTipAndAmount(
      activeLocation?.IsCatering ? 10 : 20,
      values?.Subtotal || 0,
      activeLocation?.IsCatering ? 15 : 3
    );
  };

  const handleTestOrderMode = () => {
    const now = Date.now();
    clickTimestamps.current.push(now);

    if (clickTimestamps.current.length > 5) {
      clickTimestamps.current.shift();
    }

    if (
      clickTimestamps.current.length === 5 &&
      clickTimestamps.current[4] - clickTimestamps.current[0] <= 1000
    ) {
      setIsTestOrderMode(true);
      clickTimestamps.current = [];
    }
  };

  return (
    <>
      <BADStoreAddressErrorModal
        open={storeAddressError}
        onClose={onCloseStoreAddressErrorModal}
      />
      <Formik
        initialValues={initValues}
        enableReinitialize
        innerRef={formikRef}
        validationSchema={BookADriverSchema}
        onSubmit={(values) => {
          if (isClosedForBookADriver) {
            dispatch(
              HANDLE_FAIL_MODAL({
                openFailModal: true,
                failData: {message: BOOK_A_DRIVER_ERROR.LOCATION_CLOSED}
              })
            );
            return;
          }

          if (!checkAddress?.errors) {
            const dropoffPhone = toE164UsPhone(values.Phone);
            const pickupPhone = toE164UsPhone(activeLocation?.Phone);
            if (!dropoffPhone) {
              formikRef?.current?.setErrors({
                Phone: 'Please enter a valid 10-digit US phone number'
              });
              formikRef?.current?.setFieldTouched('Phone');
              return;
            }
            if (!pickupPhone) {
              dispatch(
                HANDLE_FAIL_MODAL({
                  openFailModal: true,
                  failData: {
                    message:
                      "Restaurant's phone is not valid. Please enter a 10-digit US phone number in location settings."
                  }
                })
              );
              return;
            }
            setDisableButton(true);
            const futureDropoffTime =
              isCateringLocation || isActive === 'FutureDelivery'
                ? getFutureDate(values)
                : null;
            let body = {
              order_value: Number((values.Subtotal * 100).toFixed(0)),
              delivery_price: values.DeliveryPrice,
              items: [
                {
                  name: 'Package',
                  quantity: Number(values.ItemCount),
                  description: ''
                }
              ],
              ...(!hideEmail(AllowedServiceFeatures, order) && {
                customer_email: values.Email
              }),
              contain_alcohol: values.ContainAlcohol,
              dropoff: {
                name: values.FirstName + ' ' + values.LastName,
                phone: dropoffPhone,
                notes_v2: values.Notes,
                address: {
                  number: values.StreetNumber || '',
                  street: values.Street,
                  city: values.City,
                  state: values.State,
                  zip: values.ZipCode
                }
              },
              dropoff_loc: values.Location,
              pickup: {
                name:
                  activeLocation?.BusinessName?.trim() ||
                  activeLocation?.FullName?.trim(),
                phone: pickupPhone,
                address: {
                  number: values.StoreAddressNumber,
                  street: values.StoreAddressStreet,
                  city: values.StoreAddressCity,
                  state: values.StoreAddressState,
                  zip: values.StoreAddressZip
                }
              },
              pickup_loc: values.StoreCor,
              branch: activeLocation.FullName,
              restraunt: userData.merchant_name,
              pickup_business_name:
                activeLocation?.BusinessName?.trim() ||
                activeLocation?.FullName?.trim(),
              is_catering: isCateringLocation,
              ...(values.CoreOrderId && {core_order_id: values.CoreOrderId}),
              ...(values.InvoiceId && {core_invoice_id: values.InvoiceId}),
              ...(values.CoreOrderType && {
                core_order_type: values.CoreOrderType
              }),
              ...(isV2 && {
                reason: values.Reason,
                isV2: true,
                is_requested_by_sauce:
                  getSessionStorageItem(SESSION_SAUCE_EMPLOYEE_NAME) || false,
                percent_tip_amount: values.PercentTipAmount || 0,
                delivery_time_asap:
                  !isCateringLocation && isActive === 'ASAP'
                    ? values.ASAPFoodPreparationTime
                    : null,
                delivery_time_future:
                  isCateringLocation || isActive === 'FutureDelivery'
                    ? futureDropoffTime
                    : null
              }),
              ...(isV2 &&
                values.Reason === 'LARGE_ORDER' && {
                  amount_of_drivers: values.AmountOfDrivers || 1
                }),
              ...(values.ExternalOrderProviderName && {
                external_order_provider_name: values.ExternalOrderProviderName
              })
            };
            if (!isCateringLocation && isActive === 'ASAP') {
              body.food_preparation_time = values.ASAPFoodPreparationTime;
            }
            if (isCateringLocation || isActive === 'FutureDelivery') {
              body.dropoff_ready_dt = futureDropoffTime;
              body.dropoff_time = futureDropoffTime;
              body.food_preparation_time = activeLocation.PickupEtaMinutes;
            }
            body.tip = Math.round(values.CourierTipNumber);

            const courierCount =
              values.Reason === 'LARGE_ORDER' ? values.AmountOfDrivers || 1 : 1;

            body.total_value =
              body.order_value +
              values.DeliveryPrice * courierCount +
              Math.round(values.CourierTipNumber);

            if (isTestOrderMode) {
              body.is_test = true;
            }
            if (!disableButton) {
              sendGtmEvent('bookADriverPost', {
                subtotal: body.order_value,
                tip: body.tip,
                itemCount: values.ItemCount,
                alcohol: body.contain_alcohol,
                dropOff:
                  isActive === 'FutureDelivery' ? 'Future delivery' : 'ASAP'
                // catering: should be taken from location ?
              });
              dispatch(
                POST_BAD_ORDER({
                  data: body,
                  delivery: isActive,
                  requestedCouriers: courierCount
                })
              );
            }
          }
        }}
      >
        {({values, handleChange, errors, touched, setFieldValue}) => (
          <Form>
            <ConnectedFocusError />
            {isTestOrderMode && (
              <TestOrderModeToast onClose={() => setIsTestOrderMode(false)} />
            )}
            <DashboardContent ref={contentRef} className='DashboardContent'>
              <TopLineNav>
                <LinkBack className='NavLink'>
                  <NavLink to='/book-a-driver'>Back to Book a Driver</NavLink>
                </LinkBack>
              </TopLineNav>
              <DashboardInner className='paddingBottomXl'>
                <Subtitle5
                  onClick={handleTestOrderMode}
                  className='marginBottomLg'
                >
                  Book a <span>Driver</span>
                </Subtitle5>
                {isClosedForBookADriver && (
                  <Body1 className='RedText marginBottomSm'>
                    {BOOK_A_DRIVER_ERROR.LOCATION_CLOSED}
                  </Body1>
                )}
                <Subtitle6 className='marginBottomXs'>
                  1. Pickup Information
                </Subtitle6>
                <DashboardFields>
                  <DashboardField className='w60Plus'>
                    <FieldLabel>Your store address</FieldLabel>
                    <FieldInput
                      onChange={handleChange}
                      type='text'
                      value={values.StoreAddress}
                      name='StoreAddress'
                      className={cn('isDisabled', {
                        error: checkAddress?.errors?.StoreAddress
                      })}
                      readOnly={true}
                    />
                    <ErrorSignWrapper className='maxTwoString'>
                      {checkAddress?.errors?.StoreAddress && (
                        <ErrorSign>
                          {checkAddress?.errors?.StoreAddress}
                        </ErrorSign>
                      )}
                    </ErrorSignWrapper>
                  </DashboardField>
                </DashboardFields>
                <Subtitle6 className='marginTopXl marginBottomXs'>
                  2. Customer Information
                </Subtitle6>
                <DashboardFields>
                  <DashboardField className='w60Plus'>
                    <DashboardFields className='marginMinus'>
                      <DashboardField className='FieldNumber'>
                        <FieldLabel>Country code</FieldLabel>
                        <FieldInput
                          onChange={handleChange}
                          value={values.CountryCode}
                          readOnly={true}
                          name='CountryCode'
                          className={cn('isDisabled', {
                            error:
                              errors.CountryCode &&
                              touched.CountryCode &&
                              'error'
                          })}
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors.CountryCode &&
                              touched.CountryCode &&
                              errors.CountryCode}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                      <DashboardField className='w50Minus'>
                        <FieldLabel>Customer phone number</FieldLabel>
                        <FieldMaskInput
                          onChange={(e) => {
                            const code = phoneNumberFormatter(e.target.value);
                            setFieldValue('Phone', code);
                          }}
                          value={values.Phone}
                          mask='(999) 999-9999'
                          name='Phone'
                          className={errors.Phone && touched.Phone && 'error'}
                          onBlur={getAddresses}
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors.Phone && touched.Phone && errors.Phone}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                    </DashboardFields>
                  </DashboardField>
                  {!hideEmail(AllowedServiceFeatures, order) && (
                    <DashboardField className='w60Plus'>
                      <DashboardFields className='marginMinus'>
                        <DashboardField className='w50'>
                          <FieldLabel>Customer email</FieldLabel>
                          <FieldInput
                            type='text'
                            onChange={handleChange}
                            value={values.Email}
                            name='Email'
                            className={errors.Email && touched.Email && 'error'}
                          />
                          <ErrorSignWrapper>
                            <ErrorSign>
                              {errors.Email && touched.Email && errors.Email}
                            </ErrorSign>
                          </ErrorSignWrapper>
                        </DashboardField>
                      </DashboardFields>
                    </DashboardField>
                  )}
                  <DashboardField className='w60Plus'>
                    <DashboardFields className='marginMinus'>
                      <DashboardField className='w50'>
                        <FieldLabel>First name</FieldLabel>
                        <FieldInput
                          onChange={handleChange}
                          value={values.FirstName}
                          name='FirstName'
                          className={
                            errors.FirstName && touched.FirstName && 'error'
                          }
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors.FirstName &&
                              touched.FirstName &&
                              errors.FirstName}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                      <DashboardField className='w50'>
                        <FieldLabel>Last name</FieldLabel>
                        <FieldInput
                          onChange={handleChange}
                          value={values.LastName}
                          name='LastName'
                          className={
                            errors.LastName && touched.LastName && 'error'
                          }
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors.LastName &&
                              touched.LastName &&
                              errors.LastName}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                    </DashboardFields>
                  </DashboardField>
                  <DashboardField className='w60Plus withClear'>
                    <FieldLabel>Customer address</FieldLabel>
                    <AutocompletedMapField
                      type='text'
                      value={values.Address}
                      onChange={(e) => {
                        setFieldValue('Address', e.target.value);
                      }}
                      onBlur={() => {
                        setTimeout(() => {
                          checkDeliveryAddress(
                            formikRef?.current?.values,
                            isActive
                          );
                        }, 500);
                      }}
                      name='Address'
                      placeholder=' '
                      fieldToClear='FullAddress'
                      setFieldValue={setFieldValue}
                      className={cn('AutoComplete', {
                        error:
                          (errors.Address && touched.Address) ||
                          (errors.StreetNumber && touched.Address) ||
                          (errors.Street && touched.Address) ||
                          (errors.City && touched.Address) ||
                          (errors.State && touched.Address) ||
                          (errors.ZipCode && touched.Address) ||
                          (checkAddress && checkAddress?.errors?.DropoffAddress)
                      })}
                    />
                    {!!values.Address && (
                      <ButtonClear
                        onClick={() => {
                          setFieldValue('Location', {});
                          setFieldValue('FullAddress', '');
                          setFieldValue('Address', '');
                          setFieldValue('Country', '');
                          setFieldValue('Street', '');
                          setFieldValue('StreetNumber', '');
                          setFieldValue('City', '');
                          setFieldValue('State', '');
                          setFieldValue('ZipCode', '');
                          setFieldValue('DeliveryPrice', 0);
                          setFieldValue('DeliveryDistance', 0);
                        }}
                      />
                    )}
                    <ErrorSignWrapper className='maxTwoString'>
                      {errors.Address && touched.Address && (
                        <ErrorSign>{errors.Address}</ErrorSign>
                      )}
                      {errors.StreetNumber &&
                        !errors.Address &&
                        touched.Address && (
                          <ErrorSign>{errors.StreetNumber}</ErrorSign>
                        )}
                      {errors.Street &&
                        !errors.StreetNumber &&
                        !errors.Address &&
                        touched.Address && (
                          <ErrorSign>{errors.Street}</ErrorSign>
                        )}
                      {errors.City &&
                        !errors.StreetNumber &&
                        !errors.Street &&
                        !errors.Address &&
                        touched.Address && <ErrorSign>{errors.City}</ErrorSign>}
                      {errors.State &&
                        !errors.StreetNumber &&
                        !errors.Street &&
                        !errors.City &&
                        !errors.Address &&
                        touched.Address && (
                          <ErrorSign>{errors.State}</ErrorSign>
                        )}
                      {errors.ZipCode &&
                        !errors.StreetNumber &&
                        !errors.Street &&
                        !errors.City &&
                        !errors.State &&
                        !errors.Address &&
                        touched.Address && (
                          <ErrorSign>{errors.ZipCode}</ErrorSign>
                        )}
                      {checkAddress && checkAddress?.errors?.DropoffAddress && (
                        <ErrorSign>
                          {checkAddress?.errors?.DropoffAddress}
                        </ErrorSign>
                      )}
                    </ErrorSignWrapper>
                  </DashboardField>
                  <DashboardField className='w60Plus'>
                    <DashboardFields className='marginMinus'>
                      <DashboardField className='w33'>
                        <FieldLabel>Apartment</FieldLabel>
                        <FieldInput
                          onChange={(e) => {
                            setFieldValue('Notes.apt', e.target.value);
                          }}
                          value={values.Notes.apt}
                          name='Notes.apt'
                          type='text'
                          className={
                            errors?.Notes?.apt && touched?.Notes?.apt && 'error'
                          }
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors?.Notes?.apt &&
                              touched?.Notes?.apt &&
                              errors?.Notes?.apt}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                      <DashboardField className='w33'>
                        <FieldLabel>Floor</FieldLabel>
                        <FieldInput
                          onChange={(e) => {
                            setFieldValue('Notes.floor', e.target.value);
                          }}
                          value={values.Notes.floor}
                          name='Notes.floor'
                          type='text'
                          className={
                            errors?.Notes?.floor &&
                            touched?.Notes?.floor &&
                            'error'
                          }
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors?.Notes?.floor &&
                              touched?.Notes?.floor &&
                              errors?.Notes?.floor}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                      <DashboardField className='w33'>
                        <FieldLabel>Entrance</FieldLabel>
                        <FieldInput
                          onChange={(e) => {
                            setFieldValue('Notes.entrance', e.target.value);
                          }}
                          value={values.Notes.entrance}
                          name='Notes.entrance'
                          type='text'
                          className={
                            errors?.Notes?.entrance &&
                            touched?.Notes?.entrance &&
                            'error'
                          }
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors?.Notes?.entrance &&
                              touched?.Notes?.entrance &&
                              errors?.Notes?.entrance}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                    </DashboardFields>
                  </DashboardField>
                  <DashboardField className='w60Plus'>
                    <FieldLabel>
                      Delivery special instructions (optional)
                    </FieldLabel>
                    <FieldInput
                      onChange={handleChange}
                      value={values.Notes.notes}
                      name='Notes.notes'
                      type='text'
                      className={
                        errors?.Notes?.notes && touched?.Notes?.notes && 'error'
                      }
                    />
                    <ErrorSignWrapper>
                      <ErrorSign>
                        {errors?.Notes?.notes &&
                          touched?.Notes?.notes &&
                          errors?.Notes?.notes}
                      </ErrorSign>
                    </ErrorSignWrapper>
                  </DashboardField>
                </DashboardFields>
                <DashboardTitle className='w60Plus marginTopXl marginBottomXs'>
                  <Subtitle6>3. Delivery Information</Subtitle6>
                  <DashboardInnerDescription>
                    We’ll invoice this store automatically
                  </DashboardInnerDescription>
                </DashboardTitle>
                <DashboardFields>
                  <DashboardField className='w60Plus'>
                    <DashboardFields className='marginMinus'>
                      <DashboardField className='w33'>
                        <FieldLabel>Subtotal (excluding taxes)</FieldLabel>
                        <FieldInputDollar>
                          <FieldInput
                            onChange={(e) => {
                              setFieldValue(
                                'Subtotal',
                                amountFormatter(
                                  e.target.value,
                                  values.Subtotal,
                                  'subtotal'
                                )
                              );
                              setFieldValue(
                                'CourierTipNumber',
                                calculateTip(
                                  amountFormatter(
                                    e.target.value,
                                    values.Subtotal,
                                    'subtotal'
                                  ),
                                  values.CourierTip,
                                  values.Amount
                                )
                              );
                              if (!isV2) {
                                calculateDeliveryPrice({
                                  ...values,
                                  Subtotal: amountFormatter(
                                    e.target.value,
                                    values.Subtotal,
                                    'subtotal'
                                  )
                                });
                              }
                            }}
                            value={values.Subtotal}
                            name='Subtotal'
                            type='text'
                            className={
                              errors.Subtotal && touched.Subtotal && 'error'
                            }
                          />
                        </FieldInputDollar>
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors.Subtotal &&
                              touched.Subtotal &&
                              errors.Subtotal}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                      <DashboardField className='w33'>
                        <DashboardFields className='noWrap marginMinus'>
                          <DashboardField className='wAutoSpace'>
                            <FieldLabel>Courier tip (optional)</FieldLabel>
                            <SelectWrapper className='SelectMd w100'>
                              <FormControl className='select-formcontrol'>
                                <Select
                                  value={values.CourierTip}
                                  name='CourierTip'
                                  onChange={(e) => {
                                    setFieldValue('CourierTip', e.target.value);
                                    setFieldValue(
                                      'CourierTipNumber',
                                      calculateTip(
                                        values.Subtotal,
                                        e.target.value,
                                        values.Amount
                                      )
                                    );
                                    if (values.IsV2) {
                                      if (e.target.value === 'Custom') {
                                        setFieldValue('PercentTipAmount', 0);
                                      } else {
                                        setFieldValue(
                                          'PercentTipAmount',
                                          e.target.value
                                        );
                                      }
                                    }
                                  }}
                                  MenuProps={{
                                    anchorOrigin: {
                                      vertical: 'bottom',
                                      horizontal: 'left'
                                    },
                                    transformOrigin: {
                                      vertical: 'top',
                                      horizontal: 'left'
                                    },
                                    getContentAnchorEl: null
                                  }}
                                >
                                  <MenuItem value={0}>0</MenuItem>
                                  <MenuItem value={10}>10%</MenuItem>
                                  <MenuItem value={15}>15%</MenuItem>
                                  <MenuItem value={18}>18%</MenuItem>
                                  <MenuItem value={20}>20%</MenuItem>
                                  <MenuItem value={'Custom'}>Custom</MenuItem>
                                </Select>
                              </FormControl>
                            </SelectWrapper>
                          </DashboardField>
                          {values.CourierTip === 'Custom' && (
                            <DashboardField className='wAutoFix'>
                              <FieldLabel>Tip amount</FieldLabel>
                              <FieldInputDollar>
                                <FieldInput
                                  onChange={(e) => {
                                    setFieldValue(
                                      'Amount',
                                      amountFormatter(
                                        e.target.value,
                                        values.Amount,
                                        'amount',
                                        values.Subtotal
                                      )
                                    );
                                    setFieldValue(
                                      'CourierTipNumber',
                                      amountFormatter(
                                        e.target.value,
                                        values.Amount,
                                        'amount',
                                        values.Subtotal
                                      ) * 100
                                    );
                                    // setFieldValue(
                                    //   'CourierTipNumber',
                                    //   amountFormatter(
                                    //     e.target.value,
                                    //     values.Amount,
                                    //     'amount',
                                    //     values.Subtotal
                                    //   ) * 100
                                    // );
                                  }}
                                  name='Amount'
                                  type='text'
                                  value={values.Amount}
                                  className={cn('FieldNumber', {
                                    error: errors.Amount && touched.Amount
                                  })}
                                />
                              </FieldInputDollar>
                              <ErrorSignWrapper>
                                <ErrorSign>
                                  {errors.Amount &&
                                    touched.Amount &&
                                    errors.Amount}
                                </ErrorSign>
                              </ErrorSignWrapper>
                            </DashboardField>
                          )}
                        </DashboardFields>
                        {values?.Reason === 'LARGE_ORDER' && (
                          <DashboardText className='marginTopSm'>
                            Tip will be split between the couriers
                          </DashboardText>
                        )}
                      </DashboardField>
                      <DashboardField className='w33'>
                        <FieldLabel>Item count</FieldLabel>
                        <FieldInput
                          onChange={(e) => {
                            setFieldValue(
                              'ItemCount',
                              amountFormatter(
                                e.target.value,
                                values.ItemCount,
                                'ItemCount'
                              )
                            );
                          }}
                          value={values.ItemCount}
                          name='ItemCount'
                          type='text'
                          className={
                            errors.ItemCount && touched.ItemCount && 'error'
                          }
                        />
                        <ErrorSignWrapper>
                          <ErrorSign>
                            {errors.ItemCount &&
                              touched.ItemCount &&
                              errors.ItemCount}
                          </ErrorSign>
                        </ErrorSignWrapper>
                      </DashboardField>
                    </DashboardFields>
                  </DashboardField>
                  {/*<DashboardField className='w60Plus dFlex'>
                    <BADRadioButtons>
                      <DashboardText className='marginRightSm'>
                        Is this a catering order?
                      </DashboardText>
                      <ButtonInfo className='Outline ButtonInfoDrop marginRight4l'>
                        <div className='DropInfo DropInfoCenter DropInfoLeftMob Small DropInfoBADCatering'>
                          Sauce also offers catering services. To publish a
                          catering menu contact us at{' '}
                          <a href={'mailto: success@getsauce.com'}>
                            success@getsauce.com
                          </a>
                        </div>
                      </ButtonInfo>
                    </BADRadioButtons>
                    <RadioGroup aria-label='Is this a catering order'>
                      <DashboardFields>
                        <DashboardField className='w100 dFlex'>
                          <RadioS2E
                            label='No'
                            type='radio'
                            name='Catering'
                            checked={values.Catering === false}
                            onChange={() => {
                              setFieldValue('Catering', false);
                            }}
                          />
                          <RadioS2E
                            label='Yes'
                            type='radio'
                            name='Catering'
                            checked={values.Catering === true}
                            onChange={() => {
                              setFieldValue('Catering', true);
                              setActive('FutureDelivery');
                            }}
                          />
                        </DashboardField>
                      </DashboardFields>
                    </RadioGroup>
                  </DashboardField>*/}
                  <DashboardField className='w60Plus dFlex paddingT0'>
                    <DashboardText className='marginRightSm'>
                      <span className='asterisk'>*</span> Adding a tip helps
                      attract nearby couriers and speeds up pickup.
                    </DashboardText>
                  </DashboardField>

                  {getBookADriverVersion(AllowedServiceFeatures || []) ===
                    'v2' &&
                    isV2 && (
                      <DashboardField className='w60Plus'>
                        <DashboardFields className='marginMinus'>
                          <DashboardField className='w66'>
                            <FieldLabel>Reason</FieldLabel>
                            <SelectWrapper className='SelectMd w100'>
                              <FormControl className='select-formcontrol'>
                                <Select
                                  value={values.Reason}
                                  name='Reason'
                                  onChange={(e) => {
                                    const reason = e.target.value;
                                    setFieldValue('Reason', reason);
                                    if (reason === 'LARGE_ORDER') {
                                      setFieldValue('AmountOfDrivers', 1);
                                    } else {
                                      setFieldValue('AmountOfDrivers', null);
                                    }
                                  }}
                                  MenuProps={{
                                    anchorOrigin: {
                                      vertical: 'bottom',
                                      horizontal: 'left'
                                    },
                                    transformOrigin: {
                                      vertical: 'top',
                                      horizontal: 'left'
                                    },
                                    getContentAnchorEl: null
                                  }}
                                  className={
                                    errors.Reason && touched.Reason && 'error'
                                  }
                                >
                                  {[
                                    ...BAD_REASONS,
                                    ...(getSessionStorageItem(
                                      SESSION_SAUCE_EMPLOYEE_NAME
                                    )
                                      ? BAD_REASONS_SAUCE_ONLY
                                      : [])
                                  ].map((reason) => (
                                    <MenuItem
                                      key={reason.value}
                                      value={reason.value}
                                    >
                                      {reason.title}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </SelectWrapper>
                            <ErrorSignWrapper>
                              <ErrorSign>
                                {errors.Reason &&
                                  touched.Reason &&
                                  errors.Reason}
                              </ErrorSign>
                            </ErrorSignWrapper>
                          </DashboardField>
                          {values?.Reason === 'LARGE_ORDER' && (
                            <DashboardField className='w33'>
                              <FieldLabel>Number of couriers</FieldLabel>
                              <FieldInput
                                onChange={(e) => {
                                  setFieldValue(
                                    'AmountOfDrivers',
                                    integerFormatter(e.target.value)
                                  );
                                }}
                                value={values.AmountOfDrivers}
                                name='AmountOfDrivers'
                                type='text'
                                className={
                                  errors.AmountOfDrivers &&
                                  touched.AmountOfDrivers &&
                                  'error'
                                }
                              />
                              <ErrorSignWrapper>
                                <ErrorSign>
                                  {errors.AmountOfDrivers &&
                                    touched.AmountOfDrivers &&
                                    errors.AmountOfDrivers}
                                </ErrorSign>
                              </ErrorSignWrapper>
                            </DashboardField>
                          )}
                        </DashboardFields>
                      </DashboardField>
                    )}
                  <DashboardField className='w60Plus dFlex'>
                    <BADRadioButtons>
                      <DashboardText className='marginRightSm'>
                        Does order contain alcohol?
                      </DashboardText>
                      <ButtonInfo className='Outline ButtonInfoDrop marginRight4l'>
                        <div className='DropInfo DropInfoCenter pointer-events-none DropInfoLeftMob Small'>
                          If order includes alcoholic beverages, customer ID
                          must be shown to the courier.
                        </div>
                      </ButtonInfo>
                    </BADRadioButtons>
                    <RadioGroup aria-label='Is this order contain Alcohol'>
                      <DashboardFields>
                        <DashboardField className='w100 dFlex'>
                          <RadioS2E
                            label='No'
                            type='radio'
                            name='ContainAlcohol'
                            checked={values.ContainAlcohol === false}
                            onChange={() => {
                              setFieldValue('ContainAlcohol', false);
                            }}
                          />
                          <RadioS2E
                            label='Yes'
                            type='radio'
                            name='ContainAlcohol'
                            checked={values.ContainAlcohol === true}
                            onChange={() => {
                              setFieldValue('ContainAlcohol', true);
                            }}
                          />
                        </DashboardField>
                      </DashboardFields>
                    </RadioGroup>
                  </DashboardField>
                </DashboardFields>
                {/* <DashboardFields>
                  <DashboardField className='w100 Say2EatSelect DashboardFieldAccordion'>
                    <AccordionItem className='AccordionItemModal'>
                      <Accordion
                        onChange={handleAccordionChange('items')}
                        expanded={expanded === 'items' || expanded === true}
                      >
                        <AccordionSummary
                          aria-controls='panel1a-content'
                          id='panel1a-header'
                        >
                          <AccordionItemName className='AccordionItemName marginRightXs'>
                            4. Items including{' '}
                            {items.length > 0 ? ` (${items.length})` : ''}
                          </AccordionItemName>
                          <ButtonInfo className='Outline ButtonInfoDrop'>
                            <div className='DropInfo DropInfoCenter DropInfoLeftMob pointer-events-none'>
                              The delivery company will be responsible only for
                              the items listed. Please add all of them to this
                              order
                            </div>
                          </ButtonInfo>
                        </AccordionSummary>
                        <AccordionItemBody>
                          <DashboardFields items={items}>
                            <>
                              {items.map((item, i) => (
                                <DashboardField className='w60Plus withRemove'>
                                  <DashboardFields className='marginMinus'>
                                    <DashboardField className='wAutoSpace'>
                                      <FieldInput
                                        name='name'
                                        value={items[i].name}
                                        onChange={(e) => {
                                          handleItemItems(i, e.target.value);
                                        }}
                                      />
                                    </DashboardField>
                                    <DashboardField className='FieldNumber'>
                                      <FieldInput
                                        className='TypeNumberArrows'
                                        type='number'
                                        min='1'
                                        step='1'
                                        name='quantity'
                                        value={items[i].quantity}
                                        onChange={(e) => {
                                          handleItemQuantity(
                                            i,
                                            Number(e.target.value)
                                          );
                                        }}
                                      />
                                    </DashboardField>
                                  </DashboardFields>
                                  <DiaFieldRemove
                                    onClick={() => removeItem(i)}
                                  />
                                </DashboardField>
                              ))}
                            </>
                          </DashboardFields>
                        </AccordionItemBody>
                      </Accordion>
                    </AccordionItem>
                  </DashboardField>
                  <DashboardField className='w100'>
                    <DialogLinkButton
                      className={computedAddItem(items)}
                      onClick={() => addItem()}
                    >
                      Add an Item
                    </DialogLinkButton>
                  </DashboardField>
                </DashboardFields> */}
                <DashboardTitle className='marginTopXl marginBottomXs'>
                  <Subtitle6>4. Delivery Dropoff Time</Subtitle6>
                </DashboardTitle>
                {isCateringLocation && (
                  <Body1 className='grey2 marginBottomSm'>
                    For catering locations, only future delivery is allowed
                    (minimum 1 hour from now, up to 30 days).
                  </Body1>
                )}
                <DashboardFields>
                  <DashboardField className='w60Plus'>
                    <CardsButtonGrid className='CardsButtonGridDelivery'>
                      <CardsButton
                        className={cn('', {
                          isActive: isActive === 'ASAP',
                          isDisabled: values.Catering || isCateringLocation
                        })}
                        onClick={() => {
                          if (isCateringLocation) {
                            toggleClass('ASAP');
                            return;
                          }
                          toggleClass('ASAP');
                          checkDeliveryAddress(values, 'ASAP');
                        }}
                      >
                        <IconASAP />
                        <span>ASAP</span>
                      </CardsButton>
                      <CardsButton
                        className={
                          isActive === 'FutureDelivery' ? 'isActive' : null
                        }
                        onClick={() => {
                          toggleClass('FutureDelivery');
                          checkDeliveryAddress(values, 'FutureDelivery');
                        }}
                      >
                        <IconFutureDelivery />
                        <span>Future delivery</span>
                      </CardsButton>
                    </CardsButtonGrid>
                  </DashboardField>
                  {isActive === 'ASAP' && (
                    <DashboardField className='wAutoSpace'>
                      <DashboardField className='dFlex'>
                        <DashboardText className='mAround'>
                          Food will be ready in
                        </DashboardText>
                        <SelectWrapper className='SelectMd'>
                          <FormControl className='select-formcontrol'>
                            <Select
                              value={values.ASAPFoodPreparationTime}
                              name='ASAPFoodPreparationTime'
                              onChange={(e) => {
                                setFieldValue(
                                  'ASAPFoodPreparationTime',
                                  e.target.value
                                );
                                const body = {
                                  ...values,
                                  ASAPFoodPreparationTime: e.target.value
                                };
                                checkDeliveryAddress(body, isActive);
                              }}
                              MenuProps={{
                                // disableScrollLock: true,
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left'
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left'
                                },
                                getContentAnchorEl: null
                              }}
                            >
                              {ASAPFoodTime.map((item) => (
                                <MenuItem key={nanoid()} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </SelectWrapper>
                      </DashboardField>
                    </DashboardField>
                  )}
                  {isActive === 'FutureDelivery' && (
                    <DashboardField className='w60Plus'>
                      <DashboardFields>
                        <DashboardField className='wAuto PickerWidth100 BaDDatepicker'>
                          <FieldLabel>Delivery date</FieldLabel>
                          <SingleDatepickerDrop
                            value={values.PickupDate}
                            disablePast
                            inputFormat={'dd MMMM yyyy'}
                            minDate={
                              isCateringLocation
                                ? moment()
                                    .tz(TimezoneId)
                                    .add(1, 'hour')
                                    .toDate()
                                : undefined
                            }
                            maxDate={
                              isCateringLocation
                                ? moment()
                                    .tz(TimezoneId)
                                    .add(30, 'days')
                                    .toDate()
                                : moment(new Date())
                                    .set('month', new Date().getMonth() + 1)
                                    .toDate()
                            }
                            onAccept={(value) => {
                              setDateOrTime(value, setFieldValue, values);
                            }}
                            name='PickupDate'
                          />
                        </DashboardField>
                        <DashboardField className='wAuto PickerWidth100'>
                          <FieldLabel>Customer dropoff time</FieldLabel>
                          <div className='Say2EatSelect SauceSelectTime'>
                            <FormControl>
                              <MobileTimePicker
                                ampmInClock
                                value={values.PickupDate}
                                onChange={() => {}}
                                onAccept={(value) => {
                                  setDateOrTime(value, setFieldValue, values);
                                }}
                                minTime={getMinTime(values.PickupDate)}
                                maxTime={getMaxTime(values.PickupDate)}
                                name='PickupDate'
                                renderInput={(props) => {
                                  return <TextField {...props}></TextField>;
                                }}
                              />
                            </FormControl>
                          </div>
                        </DashboardField>
                      </DashboardFields>
                    </DashboardField>
                  )}
                  <DashboardField className='w60Plus justifyCenter flexColumn'>
                    <BADCreateTotal>
                      {values.Reason === 'LARGE_ORDER'
                        ? `Total (delivery fee for ${
                            values.AmountOfDrivers || 1
                          } couriers + tip):`
                        : 'Total (delivery fee + courier tip)'}{' '}
                      <span>
                        {checkAddressLoading ? (
                          <>
                            <Subtitle6>Calculating</Subtitle6>
                            <AnimatePoints className='Black' />
                            {/*<Loading className='LoadingSpinner' />*/}
                          </>
                        ) : (
                          <>
                            $
                            {(
                              (values.DeliveryPrice *
                                (values.Reason === 'LARGE_ORDER'
                                  ? values.AmountOfDrivers || 1
                                  : 1) +
                                values.CourierTipNumber) /
                              100
                            ).toFixed(2) || 0}
                          </>
                        )}
                      </span>
                    </BADCreateTotal>
                    <BADRecommendationText>
                      {getBookADriverVersion(AllowedServiceFeatures || []) !==
                        'v2' &&
                      values.DeliveryDistance &&
                      calcRestaurantSubsidizing(values.DeliveryDistance) ? (
                        <>
                          Recommendation: For this distance, you usually
                          subsidize deliveries by $
                          {calcRestaurantSubsidizing(values.DeliveryDistance)}.
                          Charge client $
                          {(
                            (values.DeliveryPrice +
                              values.CourierTipNumber -
                              calcRestaurantSubsidizing(
                                values.DeliveryDistance
                              ) *
                                100) /
                            100
                          ).toFixed(2)}
                        </>
                      ) : (
                        <></>
                      )}
                    </BADRecommendationText>
                  </DashboardField>
                  <DashboardField className='w60Plus justifyCenter'>
                    <ButtonPrimary
                      type='submit'
                      className={disabledSubmitButton(disableButton)}
                    >
                      {disableButton ? (
                        <span>
                          Booking
                          <AnimatePoints className='White' />
                        </span>
                      ) : (
                        <span>Book a Driver</span>
                      )}
                    </ButtonPrimary>
                  </DashboardField>
                </DashboardFields>
              </DashboardInner>
              {checkAddressLoading && (
                <Loading ref={backdropRef} className='CreateBaD' />
              )}
            </DashboardContent>
          </Form>
        )}
      </Formik>

      <OrderFail
        onClose={() => {
          setDisableButton(false);
          dispatch(HANDLE_FAIL_MODAL(false));
        }}
        open={isFailOrder}
        failData={isFailOrderData}
      />
    </>
    /**/
  );
}

CreateOrder.propTypes = {};

CreateOrder.defaultProps = {};

export default CreateOrder;
